module.exports = __webpack_public_path__ + "img/poly-8.044fa0dd.png";